import React, { useEffect, useState } from "react";
import {
  CircularProgress,
  Modal,
  Typography,
  Card,
  Grid,
  CardContent,
  Select,
  Tooltip,
  IconButton ,
  MenuItem,
  InputLabel,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  Alert, 
  AlertTitle,
} from "@mui/material";
import { Theme, useTheme } from '@mui/material/styles'
import { createStyles, makeStyles } from '@mui/styles';
import { useLocalStorage } from "../../utils/LocalStorageHook";
import { GetMaterialStrategic, getSalesOffices,GetMaterialList } from "../../utils/GetAdmin";
import requestMissingContexts, { determineConfig } from "../../utils/GetContext";
import TableAbstraction  from "../../componentUtils/TableAbstraction";
import {checkForRole} from "../../utils/GetAuth";
import LockIcon from '@mui/icons-material/Lock';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import Clear from "@mui/icons-material/Clear";
import { saveMaterialStrategic } from "../../utils/PostAdmin";

import { GetAllMaterialText, materialText } from "../../utils/GetAML"


function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
      top: `${top}%`,
      left: `${left}%`,
      transform: `translate(-${top}%, -${left}%)`,
  };
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    centerDiv: {
      textAlign: "center"
    },
    root: {},
    divWidth: {
      width: "100%",
    },
    gridSpaceable: {
      padding: theme.spacing(2),
    },
    gridMarginTop: {
      marginTop: theme.spacing(2),
    },
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    modalGrid: {
      marginTop: theme.spacing(2),
    },
    modalTitle:{
      color: theme.palette.primary.main,
    },
    modalCard: {
    },
    modalText: {
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
      width: 500,
      maxWidth: 500
    },
    modalInput: {
      paddingLeft: "20px", 
      paddingRight: "20px", 
      width:"350px"
    },
    paper: {
        position: 'absolute',
        backgroundColor: theme.palette.background.paper,
        border: `1px solid`,
        borderColor: theme.palette.border.main, 
        boxShadow: theme.shadows[4],
        padding: theme.spacing(2, 2, 2),
    },
  })
);

export default function AdminSystemConfig() {
  const classes = useStyles();
  const [materialStrategic, SetMaterialStrategic] = useState<any[]>([]);
  const [codes, setCodes] = React.useState<any>();
  const [doneLoading, setDoneLoading] = React.useState<boolean>();
  const [salesOrg,] = useLocalStorage("SETTINGS.salesOrg", "");
  const [deliveringPlants, setDeliveringPlants] = React.useState<any>();
  const [clientId,] = useLocalStorage("SETTINGS.clientId", "100");
  const enabled = checkForRole(clientId,salesOrg,'vp_admin');
  const [muiTable, setMuiTable] = React.useState<any>({rpp:25});
  const [materialTexts,setMaterialTexts] = useState<materialText[]>([]);
  const [materialList,setMaterialList] = useState<materialText[]>([]);
  
  const [useCompact] = useLocalStorage("SETTINGS.compact", true);
  const [confirmDelete, setConfirmDelete] = React.useState<boolean>(false);
 
  const handleDelete = () => {
    let oldStategy = (editedRow) ? {
      salesOffice: editedRow.salesOffice,
      deliveringPlant: editedRow.plant,
      materialNum:editedRow.materialNum,
      email:editedRow.email
    } : undefined;
    saveMaterialStrategic(salesOrg,oldStategy,undefined).then(ret => {
      //console.log(ret)
      if(ret && ret.data){
        SetMaterialStrategic(ret.data.mdMaterialStrategic)
        if(ret.data.message){
          alert(ret.data.message);
        }
      }
    }); 
    setEditedRow(undefined);
  }


  async function handleEdit(tableRow:any){
    setCurrent(tableRow);
    await getMaterialNum(editedRowDeliveringPlant);
    setOpenEditWindow(true);
  }
  const [editedRow, setEditedRow] = React.useState<any|undefined>(undefined);

  const [editedRowDeliveringPlant, setEditedRowDeliveringPlant] = React.useState<string>("");
  const [editedRowMaterialNum, setEditedRowMaterialNum] = React.useState<string>("");
  const setCurrent = (tableRow:any) => {
    setEditedRow(tableRow);
    setEditedRowDeliveringPlant(tableRow.plant);
    setEditedRowMaterialNum(tableRow.materialNum);
  }


  const [modalStyle] = React.useState(getModalStyle);
  const [openEditWindow, setOpenEditWindow] = React.useState(false);
  const handleModalClose = () => {
    setOpenEditWindow(false);
    setEditedRow(undefined);
  }
  const handleModalSave = () => {
    //console.log(editedRow, "editedRow")
    let oldStategy = (editedRow) ? {
      salesOffice: editedRow.plant,
      deliveringPlant: editedRow.plant,
      materialNum:editedRow.materialNum,
      email:editedRow.email
    } : undefined;
    let newStategy = {salesOffice:editedRowDeliveringPlant,deliveringPlant:editedRowDeliveringPlant,materialNum:editedRowMaterialNum};

    saveMaterialStrategic(salesOrg,oldStategy,newStategy).then(ret => {
     // console.log(ret)
      if(ret && ret.data){
        SetMaterialStrategic(ret.data.mdMaterialStrategic)
        if(ret.data.message){
          alert(ret.data.message);
        }
      }
    }); 
    setOpenEditWindow(false);
    setEditedRow(undefined);
  } 
  async function getMaterialNum(deliveringPlants:any){
    setEditedRowMaterialNum('all');
    let v = await GetMaterialList(salesOrg,deliveringPlants)
    if(v) setMaterialList(v);
  }
  const getMaterialText = (materialNum:string) =>{
    let materialNumShort: string = "";
    let description: string = "";
    if(materialTexts && materialTexts.length > 0){
      let mt = materialTexts.find( (mt) => mt.materialNum === materialNum);
      if(mt){
        materialNumShort = mt.materialNumShort || "";
        description = mt.description || "";
      }
    }
    return {materialNumShort,description}
  }
  const modalBody = (
    <div style={modalStyle} className={classes.paper} >
    <Typography variant="h4" className={classes.modalTitle} paragraph>Strategic Materials</Typography>
    <Grid container spacing={2} className={classes.modalGrid}>
      <Grid item xs={12}>
        <Card className={classes.modalCard}>
          <CardContent>
          <Grid container spacing={1} className={classes.modalGrid}>
            <Grid item xs={'auto'} md={'auto'} xl={'auto'}>
            <InputLabel >Delivery Plant</InputLabel>
            <Select label="Delivery Plant" required placeholder='Delivery Plant' value={editedRowDeliveringPlant}
                inputProps={{name: 'Delivery Plant',}}
                className={classes.modalInput}
                onChange={(e) => { 
                  let dp = (e.target.value &&  typeof e.target.value == 'string') ? e.target.value : "*"
                    getMaterialNum(dp);
                    setEditedRowDeliveringPlant(dp); 
                    }}>
                <MenuItem key='*' value='*'>{salesOrg + " - All"}</MenuItem>
                {(deliveringPlants)?(Object.entries(deliveringPlants).map((so: any, i: number) => (
                    <MenuItem key={so[1].code} value={so[1].code}>
                      {so[1].code + " - " + so[1].text}
                    </MenuItem>
                    ))):(<></>)}
            </Select>
            </Grid>
            <Grid item xs={'auto'} md={'auto'} xl={'auto'}>
            <InputLabel >Material</InputLabel>
            <Select label="Material" required placeholder='Material' value={editedRowMaterialNum}
                inputProps={{name: 'Material',}}
                className={classes.modalInput}
                onChange={(e) => { 
                    if(e.target.value &&  typeof e.target.value == 'string'){
                      setEditedRowMaterialNum(e.target.value); 
                    }}}>
                {(materialList)?(Object.entries(materialList).map((so: any, i: number) => (
                    <MenuItem key={so[1].material_num} value={so[1].material_num}>
                      {so[1].material_num_short} - {so[1].description}
                    </MenuItem>
                    ))):(<></>)}
            </Select>
            </Grid>
            </Grid>
            </CardContent>
          </Card>
          <div style={{ paddingRight: "5px", textAlign:"right"}}>
                <React.Fragment>
                    <Tooltip title={"Save"}>
                        <IconButton onClick={handleModalSave}>
                            <SaveIcon />
                        </IconButton>
                    </Tooltip>
                    <Tooltip title={"Cancel"}>
                        <IconButton onClick={handleModalClose}>
                            <Clear />
                        </IconButton>
                    </Tooltip>
                </React.Fragment>
              </div>
        </Grid>
      </Grid>
    </div>
  );
  useEffect(() => {
    if (doneLoading) return;
    let newCodes:any
    let matStrat:any
    let matTexts:any
    let deliveringPlants:any
    Promise.all(
      [
        (
          requestMissingContexts(["SALESOFFICES", "PLANTS"])
            .then((v) => {
              newCodes = v;
            })
        ),
        (
          GetMaterialStrategic(salesOrg).then((v) => {
            if(v && v.mdMaterialStrategic) matStrat = v.mdMaterialStrategic
          })
        ),
        (
          GetAllMaterialText()
          .then((v) => {
            //console.log(v.materialTxt)
            if(v && v.materialTxt) matTexts = v.materialTxt
          })
        ),
        (
          getSalesOffices(salesOrg).then((v) => {
            if(v) deliveringPlants = v
          })
        )
      ]
    )
    .then(()=>{
      setCodes(newCodes);
      setMaterialTexts(matTexts);
      SetMaterialStrategic(matStrat);
      setDeliveringPlants(deliveringPlants);
      setDoneLoading(true)
    })
    .catch(()=>setDoneLoading(true))
  }, [materialStrategic, doneLoading, salesOrg]);

  return (
    <div className={classes.root}>
      {doneLoading && enabled ? (
          <TableAbstraction
            settingsKey="ADM_MST"
            options={{
              draggableColumns: {
                enabled: true,
              },
              rowsPerPageOptions: [25, 50, 100],
              serverSide: false,
              selectableRows: "none",
              rowsPerPage: muiTable.rpp,
              onChangeRowsPerPage: (numberOfRows) => {
                muiTable.rpp = numberOfRows;
                setMuiTable(muiTable);
              },
              customToolbar: () => {
                return (
                  <Tooltip title={`Add Email`}>
                    <IconButton  onClick={() => {
                      handleModalClose();
                      setEditedRowDeliveringPlant("*");
                      setEditedRowMaterialNum("");
                      setOpenEditWindow(true);
                    }}>
                      <AddIcon />
                    </IconButton>
                  </Tooltip>
                );
              },
            }}
            title="Strategic Materials"
            columns={[
              {
                label: "Sales Office",
                name: "salesOffice",
                options: {
                  filter: true,
                  customBodyRender: (value: any) =>
                    value === '*' ? salesOrg :`${value} - ${determineConfig(codes, "SALESOFFICES", value)}` ,
                },
              },
              {
                label: "Delivery Plant",
                name: "plant",
                options: {
                  filter: true,
                  customBodyRender: (value: any) =>
                    value === '*' ? salesOrg :`${value} - ${determineConfig(codes, "PLANTS", value)}` ,
                },
              },
              {
                label: "Material",
                name: "materialNum",
                options: {
                  filter: true,
                  customBodyRender: (value: any) =>
                    `${getMaterialText(value)?.materialNumShort} - ${getMaterialText(value)?.description}` ,
                },
              },
              {
                label: " ",
                name: "remove",
                options: {
                  filter: false,
                  setCellProps: () => ({ align: 'right' }),
                  renderCell: (params) => {
                    if(!!useCompact)
                      return (
                          <React.Fragment>
                            <Tooltip title={"Edit"}>
                              <EditIcon 
                                fontSize="small"  
                                onClick={() => {handleEdit(params.row)}}/>
                            </Tooltip>
                            <Tooltip title={"Delete"}>
                              <DeleteIcon
                                fontSize="small" 
                                onClick={() => {setCurrent(params.row); setConfirmDelete(true);}} 
                              />
                            </Tooltip>
                          </React.Fragment>
                        );
                      else
                        return (
                            <React.Fragment>
                              <Tooltip title={"Edit"}>
                                <IconButton onClick={() => {handleEdit(params.row)}}>
                                  <EditIcon />
                                </IconButton>
                              </Tooltip>
                              <Tooltip title={"Delete"}>
                                <IconButton onClick={() => {setCurrent(params.row); setConfirmDelete(true);}}>
                                  <DeleteIcon />
                                </IconButton>
                              </Tooltip>
                            </React.Fragment>
                          );
                  },
                },
              },
            ]}
            data={materialStrategic}
          />
        ) : ( enabled ? (
          <div className={classes.centerDiv}>
            <CircularProgress color="primary" />
          </div>) : (
          <Alert severity="error">
            <AlertTitle><LockIcon/> Access Error</AlertTitle>   
            You do not currently have access to <strong>Admin</strong> activities for the <strong>{salesOrg}</strong> bottler. 
          </Alert>
          )
        )}
        <Modal
        open={openEditWindow}
        onClose={handleModalClose}
      >
        {modalBody}
      </Modal>
      <Dialog
          open={confirmDelete}
          onClose={()=>setConfirmDelete(false)}
        >
          <DialogTitle>Confirm Deletion</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Are you sure you wish to delete?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={()=>{handleDelete(); setConfirmDelete(false);}} color="primary">
              Yes
            </Button>
            <Button onClick={()=>{setEditedRow(undefined); setConfirmDelete(false);}} color="primary" autoFocus>
              No
            </Button>
          </DialogActions>
        </Dialog>
    </div>
  );
}
